import { z } from "zod";
import { CollectNodeFieldTypeEnum } from "../../../../enum/nodes.enum";

export const collectNodeCategoryFieldSchema = z.object({
  type: z.literal(CollectNodeFieldTypeEnum.CATEGORY),
  categoryValues: z
    .array(
      z.object({
        value: z.string(),
      }),
    )
    .min(1, "At least one value is required"),
  quickReply: z.boolean().default(false).optional(),
});
